// -- import * as _ from "lodash-es"
import * as _date from "date-fns"
import * as api from "../../shared/api"
import * as biz_data_helper from "../../shared/biz_data_helper"

const content_type = "sPlant_QuotationTask"

const create = function () {
  return {
    content_type: "muji",
    age: 29
  }
}
const descriptor = {}

const biz_data = new biz_data_helper.base_entity_helper(
  content_type,
  create,
  descriptor
)

const fields = {
  default: [
    { key: "id", label: "编号", sortable: true, type: "button", button: { type: "text" }, thStyle: { width: "60px" } },
    { key: 'QuotationTaskNum', label: '报价申请编号', sortable: true, thStyle: { width: '130px' } },
    { key: 'CustAccount', label: '客户账户', sortable: true, thStyle: { width: '6rem' } },
    { key: 'CustName', label: '客户名称', sortable: true, type: "short", thStyle: { width: "12rem" } },
    { key: "dataAreaId", label: "销售公司", sortable: true, thStyle: { width: "5rem" } },
    { key: "CompanyName", label: "销售公司名称", sortable: true, thStyle: { width: "10rem" }, width: "10rem", type: "short" },
    { key: "quotationType", label: "报价类型", sortable: true, type: "short" },
    { key: 'ComplateDate', label: '申请完成时间', sortable: true, type: "date", thStyle: { width: '130px' } },
    { key: 'Description', label: '描述', sortable: true, type: "short", thStyle: { width: "12rem" } },
    { key: "RelevanceNum", label: "关联报价申请", sortable: true, thStyle: { width: "8rem" }, width: "8rem", type: "short" },
    { key: 'create_by_username', label: '创建人', sortable: true, thStyle: { width: "6rem" } },
    { key: 'create_at', label: '创建时间', sortable: true, type: "datetime", thStyle: { width: "8rem" } },
    {
      key: "fcCheckSQOApproved",
      label: "审批",
      sortable: true,
      thStyle: { width: "60px" },
      type: "state",
      state_control: "fcCheckSQOApproved",
      context: ["待审批", "已审批"]
    },
    { key: "SQOApprover", label: "待审批人", sortable: true, thStyle: { width: "8rem" } },
    { key: 'fcGetDocumentQTApproveRemark', label: '审批意见', sortable: true, type: 'html' },
    { key: "is_send_email", label: "已发邮件", type: "boolean", thStyle: { width: "6rem" } },
    { key: "fcCheckSQOHasClosed", label: "有关闭", sortable: true, type: "boolean", thStyle: { width: "5rem" } },
  ],
  detail: [
    { key: 'LineNum', label: '行号', sortable: true, thStyle: { width: "60px" } },
    { key: 'ItemId', label: '物料编号', sortable: true },
    {
      key: 'NameAlias', label: '物料名称', sortable: true, type: "textarea", required: true,
      editable: true,
      thStyle: {
        width: "12rem"
      }
    },
    {
      key: 'FromBatchQty', label: '开始数量', editable: true, sortable: true, type: "number",
    },
    {
      key: 'BatchQty', label: '结束数量', editable: true, sortable: true, type: "number", required: true,
    },
    {
      key: 'Price', label: '申请报价', editable: true, sortable: true, type: "just_number", required: true,
    },
    {
      key: 'Price_Suggest', label: '建议销售价', sortable: true, type: "just_number", thStyle: { width: "6rem" }
    },
    {
      key: 'Currency', label: '币种', editable: true, sortable: true, thStyle: { width: "8rem" }
    },
    { key: 'DemandDate', label: '预计需求日期', sortable: true, type: "date", editable: true },
    { key: 'DayDemandQty', label: '日需求量', sortable: true, type: "just_number", editable: true },
    {
      key: 'InclTax', label: '是否含税', editable: true, sortable: true, thStyle: { width: "8rem" }
    },
    {
      key: 'Price_WOTax', label: '本币不含税报价', sortable: true, type: "just_number", thStyle: { width: "8rem" }
    },
    { key: 'TaxGroup', label: '税组', sortable: true },
    {
      key: 'DeliveryAddress', label: '交货地址', sortable: true, type: "textarea", required: true,
      editable: true,
      thStyle: {
        width: "12rem"
      }
    },
    {
      key: 'DeliveryMode', label: '运输方式', editable: true, sortable: true, type: "textarea", required: true,
      thStyle: {
        width: "12rem"
      }
    },
    {
      key: 'IsHomemade', label: '是否接受外协', editable: true, sortable: true, thStyle: {
        width: "8rem"
      }
    },
    {
      key: 'Manufacturer', label: '制造商', editable: true, sortable: true, type: "select_multiple", multiple: true, collapse_tags: true,
      thStyle: {
        width: "12rem"
      }
    },
    {
      key: 'Description', label: '描述', editable: true, sortable: true, type: "textarea",
      thStyle: {
        width: "12rem"
      }
    },
    {
      key: 'PriceDescription', label: '价格说明', editable: true, sortable: true, type: "textarea",
      thStyle: {
        width: "12rem"
      }
    },
    {
      key: "closed",
      label: "关闭状态",
      sortable: true,
      type: "state_closed",
      other_type_key: "closed",
      context: ["正常", "待关闭", "已关闭"]
    }
  ],
  inventTable_fields: [
    {
      key: "id",
      label: "编号",
      sortable: true,
      thStyle: { width: "60px" }
    },
    {
      key: "ItemId",
      label: "物料编号",
      sortable: true
    },

    {
      key: "NameAlias",
      label: "物料名称",
      sortable: true,
      type: "short",
      thStyle: {
        width: "12rem"
      }
    },
    {
      key: "VariantName",
      label: "变型名称",
      sortable: true,
      type: "short",
      thStyle: {
        width: "8rem"
      }
    },
    {
      key: "TEC_CustAccount",
      label: "客户帐户",
      sortable: true
    },
    {
      key: "DW_CustName",
      label: "客户名称",
      sortable: true,
      type: "short",
      thStyle: {
        width: "10rem"
      }
    },

    {
      key: "TEC_NetArea",
      label: "净面积",
      sortable: true,
      type: "number"
    },
    {
      key: "TEC_Weight",
      label: "单位重量",
      sortable: true,
      type: "number"
    },
    {
      key: "DW_InventUnitId",
      label: "单位",
      sortable: true
    }
  ],
  order_tracking: [
    { key: "id", label: "编号", sortable: true, thStyle: { width: "60px" } },
    { key: 'QuotationTaskNum', label: '报价申请编号', sortable: true, thStyle: { width: '8rem' } },
    { key: 'CustAccount', label: '客户账户', sortable: true },
    { key: 'CustName', label: '客户名称', sortable: true, type: "short", thStyle: { width: "12rem" } },
    { key: "dataAreaId", label: "销售公司", sortable: true, thStyle: { width: "5rem" } },
    { key: "CompanyName", label: "销售公司名称", sortable: true, thStyle: { width: "8rem" }, width: "8rem", type: "short" },
    { key: 'ComplateDate', label: '申请完成时间', sortable: true, type: "date", thStyle: { width: '8rem' } },
    {
      key: 'task_Description', label: '描述', sortable: true, type: "short",
      thStyle: {
        width: "8rem"
      }
    },
    { key: 'create_by_username', label: '创建人', sortable: true },
    { key: 'create_at', label: '创建时间', sortable: true, type: "datetime" },
    { key: "quotationType", label: "报价类型", sortable: true, type: "short" },
    {
      key: "fcCheckSQOrderApproved",
      label: "报价单审批",
      sortable: true,
      type: "state",
      state_control: "fcCheckSQOrderApproved",
      other_type_key: "isOrderRefused",
      context: ["待审批", "已审批", "已退回", "已完成"]
    },
    { key: "SQOrderApprover", label: "待审批人", sortable: true, thStyle: { width: "8rem" } },
    {
      key: 'SQOrderApproveRemark', label: '审批意见', sortable: true, type: 'html',
      thStyle: { width: "12rem" },
    },
    {
      key: 'SQOrderDescription', label: '报价申请退回原因', sortable: true, type: "short",
      thStyle: {
        width: "8rem"
      }
    },
    { key: 'LineNum', label: '行号', sortable: true },
    { key: 'ItemId', label: '物料编号', sortable: true },
    {
      key: 'NameAlias', label: '物料名称', sortable: true, type: "textarea", required: true,
      thStyle: {
        width: "12rem"
      }
    },
    { key: 'FromBatchQty', label: '开始数量', sortable: true, type: "number", required: true, },
    { key: 'BatchQty', label: '结束数量', sortable: true, type: "number", required: true, },
    { key: 'Price', label: '申请报价', editable: true, sortable: true, type: "just_number", required: true, },
    { key: 'Price_Suggest', label: '建议销售价', sortable: true, type: "just_number", thStyle: { width: "6rem" } },
    { key: 'TotalCost', label: '综合不含税成本', sortable: true, type: "just_number", thStyle: { width: "8rem" } },
    { key: 'GrossProfitMargin', label: '毛利率(%)', sortable: true, type: "just_number", thStyle: { width: "6rem" } },
    { key: 'ExchangeRateUpdate', label: '变动汇率', sortable: true, type: "just_number", thStyle: { width: "6rem" } },
    {
      key: 'PriceDescription', label: '价格说明', editable: true, sortable: true, type: "textarea",
      thStyle: {
        width: "12rem"
      }
    },
    {
      key: 'Currency', label: '币种', sortable: true
    },
    {
      key: 'InclTax', label: '价格是否含税', sortable: true, thStyle: {
        width: "8rem"
      }
    },
    { key: 'TaxGroup', label: '税组', sortable: true },
    {
      key: 'Price_WOTax', label: '本币不含税报价', sortable: true, type: "just_number", thStyle: { width: "8rem" }
    },
    {
      key: 'DeliveryAddress', label: '交货地址', sortable: true, type: "textarea", required: true,
      thStyle: {
        width: "12rem"
      }
    },
    {
      key: 'DeliveryMode', label: '运输方式', sortable: true, type: "textarea", required: true,
      thStyle: {
        width: "12rem"
      }
    },
    {
      key: 'IsHomemade', label: '是否接受外协', sortable: true, thStyle: {
        width: "8rem"
      },
      formatter: (value, key, item) => {
        if (item.IsHomemade == 1) return "是"
        else if (item.IsHomemade == 2) return "纯外协"
        else return "否"
      }
    },
    {
      key: 'Manufacturer', label: '制造商', sortable: true, type: "select_multiple", multiple: true, collapse_tags: true,
      thStyle: {
        width: "12rem"
      }
    },
    {
      key: 'Description', label: '明细描述', sortable: true, type: "textarea",
      thStyle: {
        width: "12rem"
      }
    },
  ],
  quote_order_close: [
    {
      key: "id",
      label: "编号",
      sortable: true,
      thStyle: { width: "60px" }
    },
    { key: 'QuotationTaskNum', label: '报价申请编号', sortable: true },
    { key: 'CustAccount', label: '客户账户', sortable: true },
    {
      key: 'CustName', label: '客户名称', sortable: true, type: "short",
      thStyle: {
        width: "12rem"
      }
    },
    {
      key: "dataAreaId",
      label: "销售公司",
      sortable: true,
      thStyle: {
        width: "5rem"
      }
    },
    {
      key: "CompanyName",
      label: "销售公司名称",
      sortable: true,
      thStyle: { width: "8rem" },
      width: "8rem",
      type: "short"
    },
    { key: 'ComplateDate', label: '申请完成时间', sortable: true, type: "date" },
    {
      key: 'task_Description', label: '描述', sortable: true, type: "short",
      thStyle: {
        width: "8rem"
      }
    },
    {
      key: "closed",
      label: "关闭状态",
      sortable: true,
      type: "state_closed",
      other_type_key: "closed",
      context: ["正常", "待关闭", "已关闭"]
    },
    {
      key: 'ApplicationDescription', label: '关闭原因', sortable: true, type: 'html',
      thStyle: { width: "12rem" },
    },
    { key: "Submitter", label: "提交人", sortable: true, thStyle: { width: "8rem" } },
    { key: 'SubmitDate', label: '提交时间', sortable: true, type: "datetime" },

    { key: 'LineNum', label: '行号', sortable: true },
    { key: 'ItemId', label: '物料编号', sortable: true },
    {
      key: 'NameAlias', label: '物料名称', sortable: true, type: "textarea", required: true,
      thStyle: {
        width: "12rem"
      }
    },
    { key: 'FromBatchQty', label: '开始数量', sortable: true, type: "number", required: true, },
    { key: 'BatchQty', label: '结束数量', sortable: true, type: "number", required: true, },
    { key: 'Price', label: '申请报价', editable: true, sortable: true, type: "just_number", required: true, },
    { key: 'Currency', label: '币种', sortable: true },
    {
      key: 'InclTax', label: '价格是否含税', sortable: true, thStyle: {
        width: "8rem"
      }
    },
    { key: 'TaxGroup', label: '税组', sortable: true },
    {
      key: 'Price_WOTax', label: '本币不含税报价', sortable: true, type: "just_number", thStyle: { width: "8rem" }
    },
    {
      key: 'DeliveryAddress', label: '交货地址', sortable: true, type: "textarea", required: true,
      thStyle: {
        width: "12rem"
      }
    },
    {
      key: 'DeliveryMode', label: '运输方式', sortable: true, type: "textarea", required: true,
      thStyle: {
        width: "12rem"
      }
    },
    {
      key: 'IsHomemade', label: '是否接受外协', sortable: true, thStyle: {
        width: "8rem"
      },
      formatter: (value, key, item) => {
        if (item.IsHomemade == 1) return "是"
        else if (item.IsHomemade == 2) return "纯外协"
        else return "否"
      }
    },
    {
      key: 'Manufacturer', label: '制造商', sortable: true, type: "select_multiple", multiple: true, collapse_tags: true,
      thStyle: {
        width: "12rem"
      }
    },
    {
      key: 'Description', label: '明细描述', sortable: true, type: "textarea",
      thStyle: {
        width: "12rem"
      }
    },
  ]
}

const dataForm = {}

///前端验证
const rules = {}
const methods = {
  //#region 报价申请主档
  async getData(_params, action_code) {
    let f = _.map(fields.default, "key")
    f.push("create_by")
    f.push("fcCheckSQOApproved(t.id)")
    f.push("fcGetSQOApprover(t.id)")
    if (action_code == "kv") { }
    else if (action_code == "quotation_task") {
      f.push("fcCheckSQODApprovedByTaskId(t.id)")
      f.push("fcCheckSQOIsCreatedCQA(t.id)")
      f.push("fcGetDocumentQTApproveRemark(t.id)")
      f.push("fcCheckSQOHasClosed(t.id)")
    }
    else if (action_code == "quotation_handle_invent") {
      f.push("fcCheckSQOInventIsOK(t.id)")
      f.push("fcCheckSQOIsAllClosed(t.id)")
      f.push("fcCheckSQOAllApplyIsCreated(t.id)")
    }
    else if (action_code) {
      f.push("fcCheckQuoteConfirmIsOk(t.id,'" + action_code + "')")
      f.push("fcCheckSQOIsAllClosed(t.id)")
      f.push("fcCheckQuoteDetailIsAllOutsourcing(t.id)")
    }
    // f.push("fcCheckQuoteAllIsOk(t.id)");

    let result = await biz_data.selectAction({ params: _params, fields: f }).run()

    if (
      result &&
      result[0].result &&
      result[0].result.data &&
      result[0].result.data.ActionResult &&
      result[0].result.data.ActionResult.Result &&
      result[0].result.data.ActionResult.Result.Data.length > 0
    ) {
      return result[0].result.data.ActionResult.Result.Data
    } else {
      return null
    }
  },
  async saveData(params) {
    let detail_biz_data = new biz_data_helper.base_entity_helper("sPlant_QuotationTask_Detail", {}, {})
    let qto_approve_biz_data = new biz_data_helper.base_entity_helper("sp_updateApproveStatus", {}, {})
    let update_status_biz_data = new biz_data_helper.base_entity_helper("update_approve_status", {}, {})
    const copy_biz_data = new biz_data_helper.base_entity_helper("CopyQuotationTask", {}, {})//复制报价申请

    let f = _.map(fields.default, "key")
    f.push("create_by")
    let _actions = []
    for (var k in params) {
      if (k == "add") {
        const code_biz_data = new biz_data_helper.base_entity_helper("get_seq", {}, {})

        //获取code
        let _p = {
          type: "CPRO",
          date: _date.format(new Date(), "yyyy-MM-dd")
        }
        _actions.push(
          code_biz_data
            .execAction({
              params: _p,
              fields: ["seq"]
            })
            .action({
              output_last_item_map: {
                seq: "QuotationTaskNum"
              }
            })
        )
        _actions.push(
          biz_data.insertAction({
            params: params[k],
            fields: f
          }).action({
            mixin_last_item_map: {
              QuotationTaskNum: "QuotationTaskNum"
            },
            output_last_item_map: {
              id: "itemId"
            }
          })
        )
        ///销售报价审批
        let sq_form = {
          itemId: "",
          documentType: "SalesQuoteApplication",
          approveType: "",
          documentCreateByUsername: params.documentCreateByUsername
        }
        _actions.push(
          qto_approve_biz_data.execAction({
            params: sq_form,
            fields: ["id"]
          }).action({
            mixin_last_item_map: {
              itemId: "itemId"
            }
          })
        )
      }
      else if (k == "edit") {
        _actions.push(
          biz_data.updateAction({
            params: params[k],
            fields: f
          }).action({})
        )
        ///销售报价审批
        let sq_form = {
          itemId: params[k].id,
          documentType: "SalesQuoteApplication",
          approveType: "",
          documentCreateByUsername: params.documentCreateByUsername
        }
        _actions.push(
          qto_approve_biz_data.execAction({
            params: sq_form,
            fields: ["id"]
          }).action({})
        )
      }
      else if (k == "delete") {
        _actions.push(
          biz_data.deleteAction({
            params: params[k],
            fields: f
          }).action({})
        )
      }
      else if (k == "approved") {
        ///更新退回原因
        if (params[k].data && params[k].data.length > 0) {
          _actions.push(
            detail_biz_data.updateAction({
              params: params[k].data,
              fields: f
            }).action({})
          )
        }
        ///执行报价单审批
        _.each(params[k].approveStatusIdList, (t) => {
          _actions.push(
            update_status_biz_data.execAction({
              params: {
                IsApproved: t.isApproved ? 0 : 1,
                ApproveBy: params[k].local_username,
                status_id: t.id,
                ApproveRemark: params[k].ApproveRemark //审批备注
              },
              fields: ["is_update_ok", "is_all_approved"]
            }).action({})
          )
        })
      }
      else if (k == "copy") {
        _actions.push(copy_biz_data.execAction({ params: params[k].data, fields: ["id"] }).action({}))
      }
    }

    let result = await api.query_batch({
      actions: _actions
    })
    if (
      result &&
      result.data &&
      result.data.BatchResult &&
      result.data.BatchResult.Actions &&
      result.data.BatchResult.Actions.length > 0
    ) {
      let rt = []
      for (var t in params) {
        if (t == "add")
          rt = result.data.BatchResult.Actions[1].Result.Data[0]
        else
          rt = result.data.BatchResult.Actions[0].Result.Data[0]
      }
      return rt
    } else {
      return null
    }
  },
  //#endregion

  //#region 报价申请明细
  async getDetailData(_params) {
    let detail_biz_data = new biz_data_helper.base_entity_helper("sPlant_QuotationTask_Detail", {}, {})
    let f = _.map(fields.detail, "key")
    f.push("id")
    f.push("QuotationTaskId")
    f.push("QuotationTaskNum")
    f.push("TransportCost")
    f.push("BomID")
    f.push("RouteID")
    f.push("BomConfirmState")
    f.push("RouteConfirmState")
    f.push("TransportConfirmState")
    f.push("InventPriceConfirmState")
    f.push("Accessory")
    f.push("fcCheckSQOConsultApplayIsCreated(t.id)")
    f.push("update_by")
    f.push("update_at")
    f.push("create_by")
    f.push("InventHandleBy")
    f.push("InventHandleAt")
    f.push("UnfoldSize")
    f.push("PurchUser")
    f.push("is_proofing_confirm")

    let result = await detail_biz_data
      .selectAction({
        params: _params,
        fields: f
      }).run()
    if (
      result &&
      result[0].result &&
      result[0].result.data &&
      result[0].result.data.ActionResult &&
      result[0].result.data.ActionResult.Result &&
      result[0].result.data.ActionResult.Result.Data.length > 0
    ) {
      return result[0].result.data.ActionResult.Result.Data
    } else {
      return null
    }
  },
  async getDetailAllOkData(_params) {
    let detail_biz_data = new biz_data_helper.base_entity_helper("get_all_ok_quote_detail", {}, {})
    let f = _.map(fields.detail, "key")
    f.push("id")
    f.push("QuotationTaskId")
    f.push("TransportCost")
    f.push("AccountNum")
    let result = await detail_biz_data.execAction({
      params: _params,
      fields: f
    }).run()
    if (
      result &&
      result[0].result &&
      result[0].result.data &&
      result[0].result.data.ActionResult &&
      result[0].result.data.ActionResult.Result &&
      result[0].result.data.ActionResult.Result.Data.length > 0
    ) {
      return result[0].result.data.ActionResult.Result.Data
    } else {
      return null
    }
  },
  async getDetailDataBySql(_params) {
    let detail_biz_data = new biz_data_helper.base_entity_helper("get_qtdetail_by_qtnum", {}, {})
    let f = _.map(fields.detail, "key")
    f.push("id")
    f.push("QuotationTaskId")
    f.push("TransportCost")
    f.push("AccountNum")
    let result = await detail_biz_data.execAction({
      params: _params,
      fields: f
    }).run()
    if (
      result &&
      result[0].result &&
      result[0].result.data &&
      result[0].result.data.ActionResult &&
      result[0].result.data.ActionResult.Result &&
      result[0].result.data.ActionResult.Result.Data.length > 0
    ) {
      return result[0].result.data.ActionResult.Result.Data
    } else {
      return null
    }
  },
  async saveDetailData(params) {
    let f = _.map(fields.detail, "key")
    f.push("id")
    f.push("QuotationTaskId")
    let detail_biz_data = new biz_data_helper.base_entity_helper("sPlant_QuotationTask_Detail", {}, {})
    let qt_approve_biz_data = new biz_data_helper.base_entity_helper("sp_updateApproveStatus", {}, {})
    let qto_approve_biz_data = new biz_data_helper.base_entity_helper("sp_updateApproveStatus_SalesQuote", {}, {})
    let update_status_biz_data = new biz_data_helper.base_entity_helper("update_approve_status", {}, {})
    let async_accessory_biz_data = new biz_data_helper.base_entity_helper("async_accessory", {}, {})
    let _actions = []
    for (var k in params) {
      if (k == "add" && params[k].length > 0) {
        _actions.push(
          detail_biz_data.insertAction({
            params: params[k],
            fields: f
          }).action({})
        )
      }
      if (k == "edit" && params[k].length > 0) {
        if (params.isUpdateAccessory) {
          _actions.push(
            async_accessory_biz_data.execAction({
              params: _.map(params[k], (t) => { return { TypeCode: "sq", QuotationTaskDetailId: t.id, Accessory: t.Accessory } }),
              fields: f
            }).action({})
          )
        }
        else if (params.isClosed) { ///编辑中仅仅修改关闭状态
          _actions.push(
            detail_biz_data.updateAction({
              params: _.map(params[k], (t) => { return { closed: 2, id: t.id } }),
              fields: f
            }).action({})
          )
        }
        else {
          _actions.push(
            detail_biz_data.updateAction({
              params: params[k],
              fields: f
            }).action({})
          )
          ///销售报价审批
          if (params[k][0].QuotationTaskId) {
            let sq_form = {
              itemId: params[k][0].QuotationTaskId,
              documentType: "SalesQuoteApplication",
              approveType: "",
              documentCreateByUsername: params.documentCreateByUsername
            }
            _actions.push(
              qt_approve_biz_data.execAction({
                params: sq_form,
                fields: ["id"]
              }).action({})
            )
          }
        }
      }
      if (k == "approved" && params[k].length > 0) {
        _actions.push(
          detail_biz_data.approveAction({
            params: params[k],
            fields: f
          }).action({})
        )
      }
      if (k == "weight_cost_confirm" && params[k].length > 0) {
        ///修改审批状态
        let dt = _.map(params[k], (t) => {
          return {
            IsApproved: t.isApproved ? 0 : 1,
            ApproveBy: params.local_username,
            status_id: t.id,
            ApproveRemark: params.ApproveRemark //审批备注
          }
        })
        _actions.push(
          update_status_biz_data.execAction({
            params: dt,
            fields: ["is_update_ok", "is_all_approved"]
          }).action({})
        )
      }
      if (k == "quote_order_approved" && params[k].length > 0) {
        _.each(params[k], (t) => {
          let sq_form = {
            ItemId: t.itemId,
            DocumentType: "SalesQuoteOrder",
            ApproveType: "",
            DocumentCreateBy: t.documentCreateByUsername,
            is_factory: t.is_factory,
            LtTargetProfit: t.LtTargetProfit
          }
          _actions.push(
            qto_approve_biz_data.execAction({
              params: sq_form,
              fields: ["id"]
            }).action({})
          )
        })
      }
      if (k == "quote_task" && params[k].clear_state) {
        _actions.push(
          biz_data.updateAction({
            params: _.map(params[k].data, (t) => { return { id: t, SQOrderDescription: null } }),
            fields: ["id"]
          }).action({})
        )
      }
      if (k == "delete" && params[k].length > 0) {
        _actions.push(
          detail_biz_data.deleteAction({
            params: params[k],
            fields: f
          }).action({})
        )
      }
    }
    let result = await api.query_batch({
      actions: _actions
    })
    if (
      result &&
      result.data &&
      result.data.BatchResult &&
      result.data.BatchResult.Actions &&
      result.data.BatchResult.Actions.length > 0
    ) {
      let is_error = false
      _.each(result.data.BatchResult.Actions, (t) => {
        if (!t.Result.Data) {
          is_error = true
        }
      })
      if (is_error) return null
      else {
        let rt = { add: [], edit: [], delete: [] }
        _.each(result.data.BatchResult.Actions, (t) => {
          if (t.Code.indexOf("data/i/") > -1) rt.add = t.Result.Data[0]
          else if (t.Code.indexOf("data/u/") > -1) rt.edit = t.Result.Data[0]
          else if (t.Code.indexOf("data/d/") > -1) rt.delete = t.Result.Data[0]
        })
        return rt
      }
    } else {
      return null
    }
  },
  ///退回报价到采购(自动生成询价申请及询价单)
  async refusedQuotationToPurch(_params) {
    const update_status_biz_data = new biz_data_helper.base_entity_helper("refuse_approve_status", {}, {})
    let result = await update_status_biz_data.execAction({ params: _params, fields: [] }).run()
    if (
      result &&
      result[0].result &&
      result[0].result.data &&
      result[0].result.data.ActionResult &&
      result[0].result.data.ActionResult.Result &&
      result[0].result.data.ActionResult.Result.Data
    ) {
      return {
        state: true,
        data: [],
        message: ""
      }
    } else {
      return null
    }
  },
  //获取关闭申请
  async getQuoteCloseApplication(_params) {
    let detail_biz_data = new biz_data_helper.base_entity_helper("get_quote_close_application", {}, {})
    let f = _.map(fields.quote_order_close, "key")
    let result = await detail_biz_data.execAction({
      params: _params,
      fields: f
    }).run()
    if (
      result &&
      result[0].result &&
      result[0].result.data &&
      result[0].result.data.ActionResult &&
      result[0].result.data.ActionResult.Result &&
      result[0].result.data.ActionResult.Result.Data.length > 0
    ) {
      return result[0].result.data.ActionResult.Result.Data
    } else {
      return null
    }
  },
  //新增关闭申请
  async addQuoteCloseApplication(params) {
    let save_biz_data = new biz_data_helper.base_entity_helper("sPlant_QuotationTask_Close_Application", {}, {})
    let detail_biz_data = new biz_data_helper.base_entity_helper("sPlant_QuotationTask_Detail", {}, {})

    let f = _.map(fields.quote_order_close, "key")
    let _actions = []
    for (var k in params) {
      _actions.push(
        save_biz_data.insertAction({
          params: params[k],
          fields: f
        }).action({})
      )
      _actions.push(
        detail_biz_data.updateAction({
          params: { id: params[k].QuotationTaskDetailId, closed: 1 },//修改报价明细closed状态为待关闭
          fields: ["id"]
        }).action({})
      )
    }
    let result = await api.query_batch({
      actions: _actions
    })
    if (
      result &&
      result.data &&
      result.data.BatchResult &&
      result.data.BatchResult.Actions &&
      result.data.BatchResult.Actions.length > 0
    ) {
      return result.data.BatchResult.Actions[0].Result.Data[0]
    } else {
      return null
    }
  },
  //执行关闭申请
  async excuteQuoteCloseApplication(params) {
    let save_biz_data = new biz_data_helper.base_entity_helper("sPlant_QuotationTask_Close_Application", {}, {})
    let detail_biz_data = new biz_data_helper.base_entity_helper("sPlant_QuotationTask_Detail", {}, {})
    let _actions = []
    for (var k in params) {
      _actions.push(
        save_biz_data.deleteAction({
          params: { id: params[k].application_id },
          fields: ["id"]
        }).action({})
      )
      //修改报价明细关闭状态
      _actions.push(
        detail_biz_data.updateAction({
          params: { id: params[k].id, closed: 2 },
          fields: ["id"]
        }).action({})
      )
    }
    let result = await api.query_batch({
      actions: _actions
    })
    if (
      result &&
      result.data &&
      result.data.BatchResult &&
      result.data.BatchResult.Actions &&
      result.data.BatchResult.Actions.length > 0
    ) {
      return result.data.BatchResult.Actions[0].Result.Data[0]
    } else {
      return null
    }
  },
  //撤销关闭申请
  async cancelQuoteCloseApplication(params) {
    let detail_biz_data = new biz_data_helper.base_entity_helper("cancel_quote_close_application", {}, {})
    let f = _.map(fields.quote_order_close, "key")
    let result = await detail_biz_data.execAction({
      params: params,
      fields: f
    }).run()
    if (
      result &&
      result[0].result &&
      result[0].result.data &&
      result[0].result.data.ActionResult &&
      result[0].result.data.ActionResult.Result &&
      result[0].result.data.ActionResult.Result.Data.length > 0
    ) {
      return result[0].result.data.ActionResult.Result.Data
    } else {
      return null
    }
  },
  //#endregion

  //#region 检查
  ///检查是否存在明细
  async checkDetailIsExists(params) {
    let check_detail_biz_data = new biz_data_helper.base_entity_helper("check_is_existe_quote_detail", {}, {})
    let _actions = []
    _actions.push(
      check_detail_biz_data.execAction({
        params: _.map(params, (t) => {
          return { QuotationTaskId: t.id }
        }),
        fields: ["IsExiste", "QuotationTaskId"]
      }).action({})
    )
    let result = await api.query_batch({
      actions: _actions
    })
    if (
      result &&
      result.data &&
      result.data.BatchResult &&
      result.data.BatchResult.Actions &&
      result.data.BatchResult.Actions.length > 0
    ) {
      let rt = result.data.BatchResult.Actions[0].Result.Data
      return rt
    } else {
      return null
    }
  },
  ///检查bom是否完成工艺绑定
  async checkBomOprNumIsOk(_params) {
    let item_biz_data = new biz_data_helper.base_entity_helper(
      "check_bom_oprnum_isok", {}, {})
    let result = await item_biz_data
      .handlerScriptAction({
        params: _params
      })
      .run()
    if (
      result &&
      result[0].result &&
      result[0].result.data &&
      result[0].result.data.ActionResult &&
      result[0].result.data.ActionResult.Result &&
      result[0].result.data.ActionResult.Result.Data.length > 0
    ) {
      return result[0].result.data.ActionResult.Result.Data
    } else {
      return null
    }
  },
  //#endregion

  //#region 报价流程
  ///计算bom成本额
  async getQuotationProgress(_params) {
    let item_biz_data = new biz_data_helper.base_entity_helper("get_quotation_progress", {}, {})
    let result = await item_biz_data.handlerScriptAction({ params: _params }).run()
    if (
      result &&
      result[0].result &&
      result[0].result.data &&
      result[0].result.data.ActionResult &&
      result[0].result.data.ActionResult.Result &&
      result[0].result.data.ActionResult.Result.Data.length > 0
    ) {
      return result[0].result.data.ActionResult.Result.Data
    } else {
      return null
    }
  },
  //#endregion
  //#region 打样报价确认
  ///打样报价分配确认前检查
  async checkBeforeConfirmQTHDPro(params) {
    let detail_biz_data = new biz_data_helper.base_entity_helper("check_before_confirm_proofing", {}, {})
    let f = _.map(fields.default, "key")
    let _actions = []
    _actions.push(
      detail_biz_data.execAction({
        params: params,
        fields: f
      }).action({})
    )

    let result = await api.query_batch({ actions: _actions })
    if (
      result &&
      result.data &&
      result.data.BatchResult &&
      result.data.BatchResult.Actions &&
      result.data.BatchResult.Actions.length > 0
    ) {
      return result.data.BatchResult.Actions[0].Result.Data
    } else {
      return null
    }
  },
  async confrimQTHDPro(params) {
    let detail_biz_data = new biz_data_helper.base_entity_helper("sPlant_QuotationTask_Detail", {}, {})
    let f = _.map(fields.default, "key")
    let _actions = []
    _actions.push(
      detail_biz_data.updateAction({
        params: params,
        fields: f
      }).action({})
    )

    let result = await api.query_batch({ actions: _actions })
    if (
      result &&
      result.data &&
      result.data.BatchResult &&
      result.data.BatchResult.Actions &&
      result.data.BatchResult.Actions.length > 0
    ) {
      return result.data.BatchResult.Actions[0].Result.Data[0]
    } else {
      return null
    }
  },
  //#endregion
}
export { biz_data, dataForm, fields, methods, rules }

